import * as React from 'react';
import Box from '@mui/material/Box';
import {
    Avatar,
    Button, Grid,
    ListItemIcon,
    Menu,
    MenuItem
} from "@mui/material";
import {ArrowDropDown, Logout, Person} from "@mui/icons-material";
import {useDispatch, useSelector} from "react-redux";
import {selectUser, userLoggedOut} from "../../store/userSlice";
import Pref from "../../inc/Pref";

export default function UserMenu() {

    const dispatch = useDispatch();
    const user = useSelector(selectUser);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return user ? <>

        <Button
            onClick={handleClick}
            variant="contained"
            size="large"
            color="secondary"
            startIcon={
                <Avatar sx={{width: 28, height: 28, background: 'white'}}>
                    <Person color="primary"/>
                </Avatar>
            }
            endIcon={
                <ArrowDropDown/>
            }>
            <Box display={{xs: 'none', md: 'block'}}>
                {user.name} {user.surname}
            </Box>
        </Button>

        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
                elevation: 0,
                sx       : {
                    overflow           : 'visible',
                    filter             : 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt                 : 1.5,
                    '& .MuiAvatar-root': {
                        width : 32,
                        height: 32,
                        ml    : -0.5,
                        mr    : 1,
                    },
                    '&::before'        : {
                        content  : '""',
                        display  : 'block',
                        position : 'absolute',
                        top      : 0,
                        right    : 14,
                        width    : 10,
                        height   : 10,
                        bgcolor  : 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex   : 0,
                    },
                },
            }}
            transformOrigin={{horizontal: 'right', vertical: 'top'}}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
        >
            <MenuItem onClick={() => {
                Pref.sessionUser = null;
                Pref.sessionToken = null;
                dispatch(userLoggedOut());
            }}>
                <ListItemIcon>
                    <Logout fontSize="small"/>
                </ListItemIcon>
                Cerrar sesión
            </MenuItem>
        </Menu>
    </> : <></>;
}
